import { excludeTab } from './regex';

import { string } from '@/validations/custom-yup';

export const maxLengthStringSchema = (label: string) => string().label(label)
  .max(1000)
  .notRequired()
  .default('')
  .ensure();

export const remarksSchema = (max = 250) => string()
  .label('備考')
  .max(max)
  .default('')
  .ensure()
  .matches(excludeTab, 'タブを削除してください。');
